import { createStore } from 'satcheljs';
import type MessageAdListViewStatusStore from './schema/MessageAdListViewStatusStore';

// Import mutators so they are initialized at the same time as the store
import '../mutators/removeMessageAdListMutator';

const initialMessageAdListViewStatusStore: MessageAdListViewStatusStore = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (11,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    selectedAdId: null,
    showAdCount: -1,
    latestAdDeleteTime: 0,
    refreshAfterDeleteInterval: 0,
    isSuperClicker: false,
};
export const getStore = createStore<MessageAdListViewStatusStore>(
    'messageAdListViewStatusStore',
    initialMessageAdListViewStatusStore
);
const store = getStore();
export default store;
